import React, { useRef } from 'react';
import Scrollbar from 'react-scrollbars-custom';
import Label from 'components/_utility/Label';
import { useSelector, useDispatch } from 'react-redux';
import { getFeatureCards } from 'src/redux/bikes/selectors';
import { setFeatureCards } from 'src/redux/bikes/actions';
import { useNavigate } from 'helpers/routing';
import {
  Wrap,
  About,
  Description,
  ViewButton,
  Bikes,
  BikeScroller,
  BikeCard,
  Title,
  Gutter,
  Hairline,
} from './FeatureBlock.styled';

const FeatureBlock = ({ id, title, description, familyCards = true, ctaColour }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const features = useSelector(getFeatureCards(familyCards ? 'genre' : 'family'));
  const cards = features[id];
  const buttonRef = useRef();
  let scrollerRef;

  if (!cards || !cards.length) {
    return null;
  }

  return (
    <Wrap hasButton={familyCards}>
      <About>
        <Title>{title}</Title>
        <Description
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        {familyCards ? (
          <ViewButton
            variant={ctaColour}
            ref={buttonRef}
            onClick={() => {
              navigate(`/families/${id}`);
            }}
          >
            <Label name="viewCollectionButton" />
          </ViewButton>
        ) : null}
        <Hairline />
      </About>
      <Bikes>
        <Scrollbar
          noDefaultStyles
          renderer={({ elementRef: _scrollerRef, ...props }) => (
            <div
              ref={ref => {
                scrollerRef = ref;
                return _scrollerRef(ref);
              }}
              {...props}
            ></div>
          )}
          onUpdate={() => {
            if (scrollerRef.classList.contains('trackXVisible') && !scrollerRef.classList.contains('trackMounted')) {
              scrollerRef.classList.add('trackMounted');

              if (buttonRef.current) {
                buttonRef.current.style.bottom = '-40px';
              }
            }
          }}
        >
          <BikeScroller cardCount={cards.length}>
            {cards.map(card => (
              <BikeCard key={card.id} bike={card} family={familyCards} />
            ))}
            {cards.length > 1 ? <Gutter></Gutter> : null}
          </BikeScroller>
        </Scrollbar>
      </Bikes>
    </Wrap>
  );
};

export default FeatureBlock;
